import React from 'react'
import styles from './Footer.module.css'

const Footer =(props) => (
    <div className={styles.Footer}>{props.children}</div>     
)

export default Footer